/**
 * OrderBy
 * @author LL
 * @date 2022-01-19 下午 04:47
 **/
export enum OrderBy {
    ASC = 'asc',
    DESC = 'desc',
}
